import * as React from 'react';

export interface ActiveTabContextValues {
  isWindowFocused: boolean;
  currentTeamId?: string;
  setCurrentTeamId?: (id?: number, skipReload?: boolean) => void;
}

export const ActiveTabContext = React.createContext<ActiveTabContextValues>({
  isWindowFocused: false,
  currentTeamId: undefined,
  setCurrentTeamId: (id?: number, skipReload?: boolean) => {},
});
